<template>
  <div
    :class="rootClass"
  >
    <div :class="formGroupClass">
      <span class="name-label">{{ label }}</span>
      <p>{{ value }}</p>
    </div>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'

export default {
  name: 'CommonInfoPlace',
  mixins: [applicationInputMixin, applicationFormMixin],

  props: {
    label: {
      default: 'Адрес'
    },

    value: {
      default: '-'
    },

    breakpoints: {
      type: Object,
      default() {
        return { md: 3, sm: 3 }
      }
    }
  },

  computed: {
    rootClass () {
      let result = '';
      for (let breakpoint in this.breakpoints) {
        result += `col-${breakpoint}-${this.breakpoints[breakpoint]} `
      }

      return result
    }
  }
}
</script>
